import { UserRolePermission } from './settings';

export type TResetPasswordReq = {
  newPassword: string;
};

export type TUserResetPasswordReq = {
  newPassword: string;
};

export enum TRole {
  Admin = 'admin',
  User = 'user',
}

export type AuthUser = Partial<{
  id: number;
  first_name: string;
  username: string;
  accountName: string;
  competitionActivationDate: string | null;
  last_name: string;
  email: string;
  phone_number: string;
  country: string;
  state: string;
  city: string;
  zipcode: string;
  createdAt: string;
  updatedAt: string;
  avatar: string;
  terms_accepted: boolean;
  referral_source: string;
  complete_onboarding: boolean;
  role: TRole;
  platform: string;
  affiliate_landing_link: string;
  affiliate_landing_short_link: string;
  affiliate_id: string;
  affiliate_payout_method_id: string;
  affiliate_payout_address: string;
  affiliate_checkout_link: string;
  affiliate_checkout_short_link: string;
  permissions: UserRolePermission[];
}>;

export type TAuthSignInReq = {
  login: string;
  password: string;
};

export type TAuthSignUpReq = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  country: string;
};
